import React from 'react';
export function MedicalDisclaimer() {
  return <div className="py-12 bg-white" data-id="element-1139">
      <div className="container mx-auto px-4" data-id="element-1140">
        <div className="max-w-4xl mx-auto" data-id="element-1141">
          <div className="mb-8" data-id="element-1142">
            <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-1143">
              Medical Disclaimer
            </h1>
            <p className="text-sm text-slate-500" data-id="element-1144">Last Updated: January 2025</p>
          </div>
          <div className="prose prose-slate max-w-none" data-id="element-1145">
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1146">
              1. Nature of Services
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1147">
              Nura Health is a medical tourism coordination service, not a
              medical provider. We do not provide medical advice, diagnosis, or
              treatment. All medical services, treatments, and procedures are
              provided exclusively by our independent partner fertility clinics
              in Europe.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1148">
              The information provided on this website is for general
              informational purposes only and is not intended as a substitute
              for professional medical advice, diagnosis, or treatment. Always
              seek the advice of qualified healthcare professionals with any
              questions you may have regarding a medical condition or treatment.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1149">
              Nura Health makes no representations or warranties about the
              accuracy, reliability, completeness, or timeliness of the medical
              information provided by our partner clinics. Any reliance you
              place on such information is strictly at your own risk.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1150">
              2. Scope of Coordination Services
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1151">
              Nura Health provides coordination services only, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1152">
              <li data-id="element-1153">Appointment scheduling with partner fertility clinics</li>
              <li data-id="element-1154">Travel and accommodation arrangements</li>
              <li data-id="element-1155">Translation and interpretation services</li>
              <li data-id="element-1156">Medical records transfer coordination</li>
              <li data-id="element-1157">Administrative support throughout your treatment journey</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1158">
              All medical decisions, treatment plans, and clinical care are the
              sole responsibility of the licensed medical professionals at our
              partner fertility clinics. Nura Health acts only as a facilitator
              to connect patients with these independent medical providers.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1159">
              3. Success Rates and Medical Outcomes
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1160">
              Success rates and statistics displayed on this website are
              provided by our independent partner fertility clinics and
              represent their historical clinical data. These statistics are for
              informational purposes only.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1161">
              Individual results may vary significantly. Success rates depend on
              numerous factors including but not limited to: age, medical
              history, specific fertility issues, lifestyle factors, and
              adherence to treatment protocols.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1162">
              Past performance and historical success rates do not guarantee
              future results. No representation is made that any patient will or
              is likely to achieve similar outcomes.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1163">
              4. Regulatory Compliance
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1164">
              Nura Health is not regulated by the U.S. Food and Drug
              Administration (FDA) or similar regulatory bodies, as we do not
              provide medical services, devices, or pharmaceuticals. All medical
              treatments are subject to the regulations of the European
              countries where our partner clinics operate.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1165">
              Our partner fertility clinics are licensed and regulated by the
              appropriate medical authorities in their respective countries.
              Patients should verify the credentials and regulatory status of
              any medical provider before proceeding with treatment.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1166">
              5. Financial Considerations
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1167">
              Prices quoted on this website are estimates and may vary based on
              individual treatment requirements, currency exchange rates, and
              clinic-specific pricing. Final costs will be confirmed by the
              partner clinic before treatment begins.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1168">
              Patients are responsible for understanding their insurance
              coverage, if any, and any potential tax implications of medical
              tourism. Nura Health does not provide financial, tax, or insurance
              advice.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1169">
              6. No Medical Relationship
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1170">
              Use of this website and our coordination services does not create
              a doctor-patient relationship between you and Nura Health or any
              of its employees. Medical relationships exist solely between
              patients and the healthcare providers at our partner clinics.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1171">
              7. Contact Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1172">
              If you have questions about this Medical Disclaimer, please
              contact us at:
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1173">
              Email: info@nurahealth.eu
            </p>
          </div>
        </div>
      </div>
    </div>;
}